import React from 'react';
import { DeepDive } from 'src/features/DA/components/templates/DeepDive';
import { PageModelLayout } from '../../components/molecules/PageModelLayout';
import { DAKeyMetrics } from '../../features/DA/components/organisms/DAKeyMetrics';
import { FilterBar } from '../../components/organisms/FilterBar';
import { GenAIActionButtons } from 'src/components/molecules/GenAIActionButtons';

export const DeepDivePage: React.FC = () => {
  return (
    <PageModelLayout
      filterBar={<FilterBar includeBenchmark />}
      pageTitle="Campaign Groups"
      keyMetrics={<DAKeyMetrics />}
      extraButtons={<GenAIActionButtons />}>
      <DeepDive />
    </PageModelLayout>
  );
};
